import { render, staticRenderFns } from "./AppChannelListView.vue?vue&type=template&id=681a8feb&"
import script from "./AppChannelListView.vue?vue&type=script&lang=js&"
export * from "./AppChannelListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports